/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateCoreConfigRequest
 */
export interface CreateCoreConfigRequest {
    /**
     *
     * @type {boolean}
     * @memberof CreateCoreConfigRequest
     */
    isDraft?: boolean;
    /**
     *
     * @type {number}
     * @memberof CreateCoreConfigRequest
     */
    schemaVersion?: number;
    /**
     *
     * @type {string}
     * @memberof CreateCoreConfigRequest
     */
    coreConfigData?: string;
    /**
     *
     * @type {string}
     * @memberof CreateCoreConfigRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the CreateCoreConfigRequest interface.
 */
export function instanceOfCreateCoreConfigRequest(
    value: object,
): value is CreateCoreConfigRequest {
    return true;
}

export function CreateCoreConfigRequestFromJSON(
    json: any,
): CreateCoreConfigRequest {
    return CreateCoreConfigRequestFromJSONTyped(json, false);
}

export function CreateCoreConfigRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateCoreConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        isDraft: json["isDraft"] == null ? undefined : json["isDraft"],
        schemaVersion:
            json["schemaVersion"] == null ? undefined : json["schemaVersion"],
        coreConfigData:
            json["coreConfigData"] == null ? undefined : json["coreConfigData"],
        reason: json["reason"] == null ? undefined : json["reason"],
    };
}

export function CreateCoreConfigRequestToJSON(
    value?: CreateCoreConfigRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        isDraft: value["isDraft"],
        schemaVersion: value["schemaVersion"],
        coreConfigData: value["coreConfigData"],
        reason: value["reason"],
    };
}
